import type { ProcessArgs } from "./parser";
import * as cheerio from "cheerio";

export function wrapReference(
  element: cheerio.Element,
  args: ProcessArgs,
): void {
  const { content } = args;
  const $ = cheerio.load(content);

  const parent = $(element).parent();

  $(element).addClass("font-light text-sm");
  $(parent).addClass("text-center w-full");
}
